import 'util/iterator-helpers-polyfill';
import 'util/apply-env-from-url';
import '@fontsource/lato/300.css';
import '@fontsource/lato/400.css';
import '@fontsource/lato/700.css';
import '@fontsource/lato/900.css';
import '@fontsource/montserrat/300.css';
import '@fontsource/montserrat/400.css';
import '@fontsource/montserrat/500.css';
import '@fontsource/montserrat/700.css';
import '@fontsource/anton/400.css';
import { createRoot } from 'react-dom/client';
import 'util/setup-yup';
import 'util/filepond';
import { prepare } from 'util/msw';
import App from './App';
import { LicenseInfo } from '@mui/x-license';
import chmln from '@chamaeleonidae/chmln';
import { i18nPromise } from './app-i18n';

chmln.init(
  'SVZK0qBQuwiJoG2mVYTkrAHpxwby9mUrU0oc6amFisIEq6-1Q7n95-EsbNPGlC4QJM2VEj',
  { fastUrl: 'https://fast.chameleon.io/' },
);

LicenseInfo.setLicenseKey(
  '35038c5ae8062f77f757b203de06b032Tz0xMjU2NTEsRT0xODAyNTYzMTk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y',
);

Promise.all([prepare(), i18nPromise]).then(() => {
  const container = document.getElementById('root');
  const root = createRoot(container);
  root.render(<App />);
});
